import { WholesaleMarketing } from "../features/wholesale/pages/wholesale-marketing"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function WholesaleMarketingPage() {
  return (
    <DashboardLayout>
      <WholesaleMarketing />
    </DashboardLayout>
  )
}
